import React from "react";

function CrossWithBGIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<rect width="32" height="32" fill="#190A28" rx="16" />
			<path
				fill="#fff"
				d="M21.097 10.911a.806.806 0 00-1.14 0L16 14.86l-3.956-3.956a.806.806 0 10-1.14 1.14L14.858 16l-3.956 3.956a.806.806 0 101.141 1.14L16 17.14l3.956 3.956a.806.806 0 101.14-1.14L17.142 16l3.956-3.956a.81.81 0 000-1.133z"
			/>
		</svg>
	);
}

export default CrossWithBGIcon;
